import template from './hero.html';
import controller from './hero.controller';
import './hero.scss';

const heroComponent = {
  bindings: {},
  template,
  controller,
};

export default heroComponent;



// WEBPACK FOOTER //
// ./client/app/common/hero/hero.component.js